import React, {useState, useEffect} from "react";
import Search from "../../../utils/search";
import Loading from "../../../utils/loading";
import { GetProductos } from "../../../../services/productosServices";

const PurchaseSuggestedAdd = ({ existingProductIds, onProductSelected, onClose }) => {
    const [loading, setLoading] = useState(false);
    const [productos, setProductos] = useState([]);
    const [searchText, setSearchText] = useState("");

    useEffect(() => {
        cargarProductos();
    }, []);

    const cargarProductos = async () => {
        try {
            setLoading(true);
            const data = await GetProductos();
            // Filter out products where Activo=0
            const filteredActive = data.filter(p => p.activo === true);
            // Filter out products that already exist in the PurchaseSuggested list
            const filtered = filteredActive.filter(p => !existingProductIds.includes(p.id));
            setProductos(filtered);
        } catch (error) {
            console.error("Error al cargar productos", error);
            alert("Error al cargar productos");
        } finally {
            setLoading(false);
        }
    };

    const filteredProductos = () => {
        if (!searchText) return productos;
        const lowerSearch = searchText.toLowerCase();
        return productos.filter(p => 
            p.descripcion.toLowerCase().includes(lowerSearch) ||
            (p.codigoBarras && p.codigoBarras.toLowerCase().includes(lowerSearch))
        );
    };

    return (
        <div className="modal">
            <div className="modal--content suggested--add-modal">
                <div className="modal--header" style={{gridTemplateColumns: '1fr 3rem'}}>
                    <div className="title" style={{textAlign: 'left', padding: 0, gridColumn: 1}}>Agregar Producto</div>
                    <div className="close-btn" onClick={onClose} style={{cursor: 'pointer', gridColumn: 2, textAlign: 'right'}}>
                        <i className="fas fa-times"></i>
                    </div>
                </div>
                
                <div className="modal--body padding-1">
                    <Search 
                        initialSearchText={searchText}
                        onSearch={(text) => setSearchText(text)}
                    />
                    
                    {loading && <Loading />}
                    
                    <div className="page-list" style={{maxHeight: '60vh', overflowY: 'auto'}}>
                        {filteredProductos().map(p => (
                            <div key={p.id} className="list-item" onClick={() => onProductSelected(p.id)} style={{cursor: 'pointer'}}>
                                <div className="col1" style={{paddingRight: '1rem'}}>
                                    <img className="thumbnail" src={p.imagenUrl} alt={p.descripcion} style={{width: '60px', height: '60px'}} />
                                </div>
                                <div className="col2">
                                    <div className="list-item--heading" style={{fontSize: '1.4rem'}}>{p.descripcion}</div>
                                    <div className="list-item--subheading" style={{fontSize: '1.2rem', color: '#666'}}>{p.categoria}</div>
                                </div>
                            </div>
                        ))}
                        {!loading && filteredProductos().length === 0 && (
                            <div style={{textAlign: 'center', padding: '2rem'}}>No se encontraron productos</div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PurchaseSuggestedAdd;
